import { useParams } from "react-router";
import { useApiClient } from "../../shared/customHooks";
import ManageUserComponent from "../../components/applicationComponents/manageUserComponent.tsx/ManageUserComponent";
import { PageHeader } from "../../components/header/PageHeader";

export default function ManageDepartmentUserPage() {
  const api = useApiClient("UserManagement", { identity: true });
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <PageHeader
        headerText={[
          {
            value: "Department User Details",
            icon: "view-app-icon icon-spec mr-3 mt-0",
          },
        ]}
        icon={"icon"}></PageHeader>
      <ManageUserComponent api={api} id={id} useDateModified={true} useUserModified={true} showAccountAccess={true} />
    </>
  );
}
